import { format, isValid, parse } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const DISPLAY_FORMAT = 'dd/MM/yy';

const PARSE_FORMATS = ['dd/MM/yy', 'dd/MM/yyyy', 'ddMMyyyy', 'ddMMyy'];

export function formatReportDateString(date: Date): string {
  return format(date, DISPLAY_FORMAT, { locale: ptBR });
}

export function parseReportDateString(value: string | undefined): Date | undefined {
  const trimmed = (value ?? '').trim();
  if (!trimmed) return undefined;

  for (const pattern of PARSE_FORMATS) {
    const parsed = parse(trimmed, pattern, new Date());
    if (isValid(parsed)) return parsed;
  }

  return undefined;
}

export function isValidReportDateString(value: string | undefined): boolean {
  return parseReportDateString(value) !== undefined;
}
